import registry from "../registry/material-symbols.json";

export type FunctionalSymbolSemantic =
  | "trajectory.pursuit"
  | "trajectory.pursuits"
  | "interpretation.pending"
  | "interpretation.revise"
  | "interpretation.more-toggle"
  | "feedback"
  | "emotion.open"
  | "emotion.close"
  | "construct.idea"
  | "construct.belief"
  | "construct.agreement"
  | "stance.agree.pending"
  | "stance.agree.set"
  | "stance.disagree.pending"
  | "stance.disagree.set"
  | "stance.ignore.pending"
  | "stance.ignore.set"
  | "stance.agree.undo"
  | "stance.disagree.undo"
  | "stance.ignore.undo"
  | "reflection"
  | "reflection.summary"
  | "reflection.rationale"
  | "project.publish"
  | "project.unpublish"
  | "project.conject"
  | "project.follow"
  | "project.unfollow"
  | "scene.experience"
  | "hallway.threshold.closed"
  | "hallway.threshold.open"
  | "hallway.return"
  | "hallway.room.available"
  | "hallway.room.unavailable"
  | "hallway.room.preferences"
  | "hallway.gate"
  | "character.synthetic"
  | "consent.manage"
  | "narrative.continue"
  | "voice.start"
  | "voice.stop"
  | "account.profile"
  | "common.menu"
  | "common.close"
  | "common.search"
  | "common.send"
  | "common.info"
  | "common.history"
  | "common.download"
  | "common.logout"
  | "common.expand"
  | "common.next"
  | "common.edit"
  | "common.refresh"
  | "common.add"
  | "common.warning";

export interface FunctionalSymbolDefinition {
  semantic: FunctionalSymbolSemantic;
  symbol: string;
  codepoint: string;
  accessibleLabel: string;
  fallbackText: string;
  category: string;
  surfaceTerms: string[];
}

interface FunctionalSymbolRegistry {
  schemaVersion: string;
  family: string;
  style: string;
  source: {
    repository: string;
    commit: string;
    assetPath: string;
    license: string;
  };
  icons: FunctionalSymbolDefinition[];
}

export const functionalSymbolRegistry = registry as FunctionalSymbolRegistry;

const definitionsBySemantic = new Map<string, FunctionalSymbolDefinition>(
  functionalSymbolRegistry.icons.map(
    (definition) => [definition.semantic, definition] as const,
  ),
);

export function resolveFunctionalSymbol(
  semantic: string,
): FunctionalSymbolDefinition | undefined {
  return definitionsBySemantic.get(semantic);
}
